import * as React from 'react';
import s from './bugFixArticle.scss';
import {convertToHTML} from '../../../utils/article-utils/formatter';
import ArticleLabels from '../ArticleLabels';
import {Article} from '../../../reducers/article';

type BugFixArticleProps = {
  article: Article,
};

class BugFixArticle extends React.Component<BugFixArticleProps, {}> {
  private checkboxInput: HTMLInputElement;

  render() {
    const {article} = this.props;
    const {date, title, content, id, labels} = article;
    return (
      <li className={s.article} data-hooks="single-bug-fix-article">
        <input
          type="checkbox"
          className={s.toggleContent}
          id={`check-${id}`}
          hidden
          ref={input => (this.checkboxInput = input)}
        />
        <button
          className={s.svgArrow}
          onClick={() =>
            (this.checkboxInput.checked = !this.checkboxInput.checked)
          }
        >
          <svg
            height="10"
            width="16"
            viewBox="0 0 16 10.406"
            className={s.svgWrapper}
          >
            <defs />
            <path
              className={s.svgCls}
              id="arrow"
              d="M1481,619.812l-7,7.01-7-7.01"
              transform="translate(-1466 -617.406)"
            />
          </svg>
        </button>
        <h2 className={s.title} data-hooks="bug-fix-article-title">
          {title}
        </h2>

        <div className={s.infoSection}>
          <ArticleLabels labels={labels} articleId={id} />
          <svg
            height="12"
            width="12"
            viewBox="0 0 12 12"
            className={s.clockIcon}
          >
            <defs />
            <path
              id="Time"
              d="M643,635a6,6,0,1,0,6,6A6,6,0,0,0,643,635Zm0,11a5,5,0,1,1,5-5A5.006,5.006,0,0,1,643,646Zm0-7h-1v3h3v-1h-2v-2Z"
              transform="translate(-637 -635)"
            />
          </svg>
          <label data-hooks="bug-fix-article-date" className={s.date}>
            {date}
          </label>
        </div>
        <div data-hooks="bug-fix-article-content" className={s.articleContent}>
          {convertToHTML(content)}
        </div>
      </li>
    );
  }
}
export default BugFixArticle;
